/// <reference path="../../../../typings/tsd.d.ts" /> 
var warsApp;
(function (warsApp) {
    var models;
    (function (models) {
        var WorkflowBlockManager = /** @class */ (function () {
            function WorkflowBlockManager() {
            }
            WorkflowBlockManager.createWorkflowBlock = function (type, id, drawingInstance) {
                var block;
                var name = WorkflowBlockManager.getWorkflowBlockNameByType(type);
                switch (type) {
                    case 0 /* State */:
                        block = new models.StateWorkflowBlock(id, name);
                        break;
                    case 2 /* Condition */:
                        block = new models.ConditionWorkflowBlock(id, name);
                        break;
                    case 1 /* UserAction */:
                        block = new models.UserActionWorkflowBlock(id, name);
                        break;
                    case 5 /* CustomAction */:
                        block = new models.CustomActionWorkflowBlock(id, name);
                        break;
                    case 98 /* Goto */:
                        block = new models.GotoWorkflowBlock(id, name);
                        break;
                    case 4 /* StatusChange */:
                        block = new models.StatusChangeWorkflowBlock(id, name);
                        break;
                    case 3 /* Message */:
                        block = new models.MessageWorkflowBlock(id, name);
                        break;
                    case 6 /* Validate */:
                        block = new models.ValidateWorkflowBlock(id, name);
                        break;
                    case 7 /* CreatePdfAction */:
                        block = new models.CreatePdfWorkflowBlock(id, name);
                        break;
                    case 19 /* Copy */:
                        block = new models.CopyWorkflowBlock(id, name);
                        break;
                    case 20 /* SetData */:
                        block = new models.SetDataWorkflowBlock(id, name);
                        break;
                    case 21 /* AssignClaim */:
                        block = new models.AssignClaimWorkflowBlock(id, name);
                        break;
                    case 8 /* SendEmailAction */:
                        block = new models.SendEmailWorkflowBlock(id, name);
                        break;
                    case 9 /* CalculateAction */:
                        block = new models.CalculateWorkflowBlock(id, name);
                        break;
                    case 11 /* BookResource */:
                        block = new models.BookResourceWorkflowBlock(id, name);
                        break;
                    case 12 /* RemoveResource */:
                        block = new models.RemoveResourceWorkflowBlock(id, name);
                        break;
                    case 16 /* ReturnFromProcessAction */:
                        block = new models.ReturnFromProcessActionWorkflowBlock(id, name);
                        break;
                    case 13 /* ProcessAction */:
                        block = new models.ProcessActionWorkflowBlock(id, name);
                        break;
                    case 17 /* SystemAction */:
                        block = new models.SystemActionWorkflowBlock(id, name);
                        break;
                    case 14 /* ChangeState */:
                        block = new models.ChangeStateWorkflowBlock(id, name);
                        break;
                    case 18 /* GotoState */:
                        block = new models.GotoStateWorkflowBlock(id, name);
                        break;
                    default:
                        throw 'Type: ' + type + ' is not a known type';
                }
                block.setDrawingInstance(drawingInstance);
                return block;
            };
            WorkflowBlockManager.createDropZone = function (id, required, drawingInstance) {
                var block = new models.DropZoneWorkflowBlock(id, required);
                block.setDrawingInstance(drawingInstance);
                return block;
            };
            WorkflowBlockManager.createInitialWorkflowBlock = function (id, drawingInstance) {
                var block = new models.StateWorkflowBlock(id, "Initial State", true);
                block.setDrawingInstance(drawingInstance);
                return block;
            };
            WorkflowBlockManager.getValidBlockTypes = function () {
                return [
                    "svgDropZone", "state", "condition", "statusChange",
                    "userAction", "systemAction", "processAction", "goto", "message", "validate",
                    "createPdf", "sendEmail", "calculate", "bookResource", "removeResource",
                    "startProcessAction", "returnFromProcessAction", "changeState", "gotoState",
                    "copy", "setData", "assignClaim"
                ];
            };
            WorkflowBlockManager.getWorkflowBlockNameByType = function (type) {
                switch (type) {
                    case 0 /* State */:
                        return "Workflow State";
                    case 2 /* Condition */:
                        return "Condition";
                    case 1 /* UserAction */:
                        return "User Action";
                    case 5 /* CustomAction */:
                        return "System Action";
                    case 4 /* StatusChange */:
                        return "Status Change";
                    case 3 /* Message */:
                        return "Message";
                    case 6 /* Validate */:
                        return "Validate";
                    case 7 /* CreatePdfAction */:
                        return "Create PDF";
                    case 19 /* Copy */:
                        return "Copy";
                    case 20 /* SetData */:
                        return "Set Data";
                    case 21 /* AssignClaim */:
                        return "Assign Claim";
                    case 8 /* SendEmailAction */:
                        return "Send Email";
                    case 9 /* CalculateAction */:
                        return "Calculate";
                    case 98 /* Goto */:
                        return "Go To";
                    case 99 /* DropZone */:
                        return "Drop Zone";
                    case 11 /* BookResource */:
                        return "Book";
                    case 12 /* RemoveResource */:
                        return "Un-Book";
                    case 15 /* StartProcessAction */:
                        return "Start";
                    case 16 /* ReturnFromProcessAction */:
                        return "Return";
                    case 13 /* ProcessAction */:
                        return "Process Action";
                    case 17 /* SystemAction */:
                        return "System Action";
                    case 14 /* ChangeState */:
                        return "Change State";
                    case 18 /* GotoState */:
                        return "Goto State";
                    default:
                        throw 'Type: ' + type + ' is not a known type';
                }
            };
            WorkflowBlockManager.getValidToBlockTypes = function (type) {
                switch (type) {
                    case 0 /* State */:
                        return [
                            1 /* UserAction */,
                            99 /* DropZone */,
                            13 /* ProcessAction */,
                            98 /* Goto */
                        ];
                    case 2 /* Condition */:
                    case 1 /* UserAction */:
                    case 5 /* CustomAction */:
                    case 3 /* Message */:
                    case 6 /* Validate */:
                    case 7 /* CreatePdfAction */:
                    case 19 /* Copy */:
                    case 20 /* SetData */:
                    case 21 /* AssignClaim */:
                    case 8 /* SendEmailAction */:
                    case 9 /* CalculateAction */:
                    case 11 /* BookResource */:
                    case 12 /* RemoveResource */:
                    case 13 /* ProcessAction */:
                    case 17 /* SystemAction */:
                    case 14 /* ChangeState */:
                        return this.getValidInlineToStates();
                    case 15 /* StartProcessAction */:
                        return this.getValidProcessActionInlineStates().concat(1 /* UserAction */);
                    case 98 /* Goto */:
                        return [
                            0 /* State */,
                            2 /* Condition */,
                            4 /* StatusChange */,
                            18 /* GotoState */,
                            5 /* CustomAction */,
                            3 /* Message */,
                            6 /* Validate */,
                            7 /* CreatePdfAction */,
                            19 /* Copy */,
                            20 /* SetData */,
                            21 /* AssignClaim */,
                            8 /* SendEmailAction */,
                            9 /* CalculateAction */,
                            11 /* BookResource */,
                            12 /* RemoveResource */,
                            16 /* ReturnFromProcessAction */,
                            13 /* ProcessAction */,
                            17 /* SystemAction */,
                            1 /* UserAction */,
                            14 /* ChangeState */,
                        ];
                    case 4 /* StatusChange */:
                    case 99 /* DropZone */:
                    case 16 /* ReturnFromProcessAction */:
                    case 18 /* GotoState */:
                        return [];
                    default:
                        throw 'Type: ' + type + ' is not a known type';
                }
            };
            WorkflowBlockManager.getValidInlineToStates = function () {
                return [
                    0 /* State */,
                    2 /* Condition */,
                    4 /* StatusChange */,
                    18 /* GotoState */,
                    5 /* CustomAction */,
                    3 /* Message */,
                    98 /* Goto */,
                    6 /* Validate */,
                    99 /* DropZone */,
                    7 /* CreatePdfAction */,
                    19 /* Copy */,
                    20 /* SetData */,
                    21 /* AssignClaim */,
                    8 /* SendEmailAction */,
                    9 /* CalculateAction */,
                    11 /* BookResource */,
                    12 /* RemoveResource */,
                    16 /* ReturnFromProcessAction */,
                    13 /* ProcessAction */,
                    17 /* SystemAction */,
                    14 /* ChangeState */
                ];
            };
            WorkflowBlockManager.getValidProcessActionInlineStates = function () {
                return [
                    2 /* Condition */,
                    5 /* CustomAction */,
                    3 /* Message */,
                    98 /* Goto */,
                    6 /* Validate */,
                    99 /* DropZone */,
                    7 /* CreatePdfAction */,
                    19 /* Copy */,
                    20 /* SetData */,
                    21 /* AssignClaim */,
                    8 /* SendEmailAction */,
                    9 /* CalculateAction */,
                    11 /* BookResource */,
                    12 /* RemoveResource */,
                    16 /* ReturnFromProcessAction */,
                    13 /* ProcessAction */,
                    17 /* SystemAction */,
                    14 /* ChangeState */
                ];
            };
            WorkflowBlockManager.intialDropZoneId = 10000;
            WorkflowBlockManager.initialGotoId = 20000;
            return WorkflowBlockManager;
        }());
        models.WorkflowBlockManager = WorkflowBlockManager;
    })(models = warsApp.models || (warsApp.models = {}));
})(warsApp || (warsApp = {}));
